import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'antd';
import Styled from './styled';
import { useText } from './Text';

const CustomCheckOnlyOne = ({ checkAll, setCheckAll }) => {
  const [checkedList, setCheckedList] = useState([]);

  const options = [
    { label: useText('monday'), value: 'pazartesi' },
    { label: useText('tuesday'), value: 'sali' },
    { label: useText('wednesday'), value: 'carsamba' },
    { label: useText('thursday'), value: 'persembe' },
    { label: useText('friday'), value: 'cuma' },
    { label: useText('saturday'), value: 'cumartesi' },
    { label: useText('sunday'), value: 'pazar' },
  ];

  useEffect(() => {
    if (checkAll) {
      setCheckedList(options.map(option => option.value));
    } else if (checkedList.length === options.length) {
      setCheckedList([]);
    }
  }, [checkAll]);

  const onChange = (list) => {
    setCheckedList(list);
    if (list.length !== options.length && checkAll) {
      setCheckAll(false);
    }
  };

  return (
    <Styled>
      <Checkbox.Group
        options={options}
        value={checkedList}
        onChange={onChange}
        className="day-checkbox-group"
      />
    </Styled>
  );
};

CustomCheckOnlyOne.propTypes = {
  checkAll: PropTypes.bool.isRequired,
  setCheckAll: PropTypes.func.isRequired,
};

export default CustomCheckOnlyOne;
